import { FC } from 'react'

import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { landingPageUrl } from 'src/Constants/links'
import CloseIconWhite from 'src/Assets/Svg/closeWhite.svg?react'
import CloseIconGreen from 'src/Assets/Svg/closeGreen.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { RoleSelect } from 'src/Components/RoleSelect'
import { Roles } from 'src/Constants/enums'
import { login } from 'src/Router/routes'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'

const CloseButton = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  & svg {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
    top: 45.5px;
    right: 44.5px;
    & svg {
      width: 16px;
      height: 16px;
    }
  }
`

const Logo = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: auto;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 32px 16px;
  }
`

const logo = '/logo.png'

export const SignUpRoleSelect: FC = () => {
  const navigate = useNavigate()

  const onGoToLanding = (): void => {
    window.location.href = landingPageUrl
  }

  const onSelectRole = (role: Roles): void => {
    if (role === Roles.artist) {
      navigate(
        `${PublicRoutesEnum.CreateSpotifyCampaign}${PublicRoutesEnum.SignUpArtist}`,
      )
      return
    }

    navigate(
      role === Roles.curator
        ? PublicRoutesEnum.SignUpCurator
        : PublicRoutesEnum.SignUpCreator,
    )
  }

  const isMobile = useMediaQuery({ maxWidth: 576 })

  return (
    <Wrapper>
      <CloseButton data-testid='close-button' onClick={onGoToLanding}>
        {isMobile ? <CloseIconGreen /> : <CloseIconWhite />}
      </CloseButton>
      <Container>
        <Logo>
          <img width={236} height={52} alt='logo' src={logo} />
        </Logo>
        <RoleSelect
          variant='signup'
          onSelectRole={onSelectRole}
          onFooterAction={() => navigate(login)}
        />
      </Container>
    </Wrapper>
  )
}
